// ==========================================================================
// TRIGGERS REBUY
// ==========================================================================

document.addEventListener('rebuy:cart.change', function (event) {
  var detail = event.detail || {};
  var cart = (detail.cart && detail.cart.cart) || detail.cart || detail;
  if (!cart || typeof cart.item_count !== 'number') return;
  var qtyRebuy = (window.CubittVisibleCount && cart.items) ? window.CubittVisibleCount(cart) : cart.item_count;
  document.querySelectorAll('.header__cart-count cart-count.count-bubble').forEach(function (el) {
    el.textContent = qtyRebuy;
    el.classList.toggle('opacity-0', qtyRebuy <= 0);
  });
  
});